import React, { memo } from 'react';

import { Skeleton } from '@/components/ui/skeleton';

import type { IItemData } from '../../api/HandRequest.interface';

import { AutoCompleteItems } from './ItemsAutoComplete';

type Props = {
  options: IItemData[] | undefined;
  handleSelectItems: (newValue: IItemData | null) => void;
  selectedItem: IItemData | null;
  selectItemRef: React.MutableRefObject<HTMLInputElement | null>;
  fnToGoToQtyRef: () => void;
  disabled: boolean;
};

// Loading state component
const LoadingState = memo(() => (
  <Skeleton className="mb-2 grid h-12 w-[380px] place-content-center">
    🔄 جاري تحميل الاصناف 📦 ⏳
  </Skeleton>
));

LoadingState.displayName = 'LoadingState';

// AutoComplete wrapper component
const AutoCompleteWrapper = memo(
  ({
    options,
    handleSelectItems,
    selectedItem,
    selectItemRef,
    fnToGoToQtyRef,
    disabled,
  }: {
    options: IItemData[];
    handleSelectItems: (newValue: IItemData | null) => void;
    selectedItem: IItemData | null;
    selectItemRef: React.MutableRefObject<HTMLInputElement | null>;
    fnToGoToQtyRef: () => void;
    disabled: boolean;
  }) => (
    <div className="flex w-full flex-wrap items-center justify-center gap-1">
      <AutoCompleteItems
        options={options}
        placeholder="اختر الصنف"
        emptyMessage="لا يوجد بيانات"
        value={selectedItem}
        onValueChange={handleSelectItems}
        selectItemRef={selectItemRef}
        fnToGoToQtyRef={fnToGoToQtyRef}
        disabled={disabled}
      />
    </div>
  ),
);

AutoCompleteWrapper.displayName = 'AutoCompleteWrapper';

// Main component implementation
const ItemsSelectComponent = ({
  options,
  handleSelectItems,
  selectedItem,
  selectItemRef,
  fnToGoToQtyRef,
  disabled,
}: Props) => {
  return (
    <div className="w-full">
      {options ? (
        <AutoCompleteWrapper
          options={options}
          handleSelectItems={handleSelectItems}
          selectedItem={selectedItem}
          selectItemRef={selectItemRef}
          fnToGoToQtyRef={fnToGoToQtyRef}
          disabled={disabled}
        />
      ) : (
        <LoadingState />
      )}
    </div>
  );
};

// Export memoized component to prevent unnecessary re-renders
export const ItemsSelect = memo(ItemsSelectComponent);

ItemsSelectComponent.displayName = 'ItemsSelectComponent';
